export default "__VITE_ASSET__kp9jt4rl__"